import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";

import { CITY } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";
import { CITY_INFORMATION } from "@/shared/resource/constants";

export const useCityStore = defineStore("city", {
  state: () => ({
    entities: [],
    totalEntities: 0,
    information: [...CITY_INFORMATION],
  }),

  actions: {
    clearEntities() {
      this.entities = [];
      this.totalEntities = 0;
    },

    async delete(id) {
      const response = await api.delete(CITY.DELETE(id));
      return response.data;
    },

    async fetch({ page = 1, limit = 10 } = {}) {
      this.clearEntities();

      const response = await api.get(CITY.GET, {
        params: { page_no: page, limit },
      });
      const data = response?.data?.data || [];

      const formattedEntities = data.map((city) => ({
        uuid: city.id,
        id: city.city_id,
        cityName: city.city_name,
        createdAt: dateTime.formatDateTime(city.created_at),
        status: city.is_active,
      }));

      this.setEntities(formattedEntities, response?.data?.total_entries || 0);
      return formattedEntities;
    },

    async fetchRoutesByCityId(cityIds) {
      const response = await api.post(CITY.GET_ROUTES_BY_CITY_ID, {
        city_ids: cityIds,
      });
      return response.data;
    },

    async getCityById(id) {
      const response = await api.get(CITY.GET_BY_ID(id));
      return response.data;
    },

    async save({ name, id }) {
      let response;
      if (id) {
        response = await api.put(CITY.UPDATE(id), { city_name: name });
      } else {
        response = await api.post(CITY.POST, { city_name: name });
      }
      return response.data;
    },

    setEntities(entities, totalEntities) {
      this.entities = entities;
      this.totalEntities = totalEntities;
    },
  },

  getters: {
    getEntities: (state) => state.entities,
    getTotalEntities: (state) => state.totalEntities,
    getInformation: (state) => state.information,
  },
});
